import React from "react";
import content from "../utils/content.json";
function Contact() {
  return (
    <div className="background">
      <div id="contact" className="container section">
        <div className="row">
          <div className="col-md-12">
            <p id="contacts_header" className="section__title">
              Get in touch_
            </p>
          </div>
        </div>
        <div className="row contacts">
          <div className="col-md-6">
            <div className="contacts__list">
              <dl className="contact-list">
                <dt>Email:</dt>
                <dd>
                  <a href={`mailto:${content.content.profile.contacts.email}`}>
                    {content.content.profile.contacts.email}
                  </a>
                </dd>
              </dl>
            </div>
          </div>
          <div className="col-md-6">
            <div className="contacts__social">
              <br />
              <ul>
                <li>
                  <a
                    href={content.content.profile.social.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="footer">
            <p>
              © {new Date().getFullYear()} Malvika Souran. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
